import './SideNav.less';
import React from 'react';
import LocaleSwitcher from "../locale-switcher/LocaleSwitcher";
import NavItemsView from "./nav-items-view/NavItemsView";
import NavigationContext from "../../contexts/navigation/NavigationContext";


export default function SideNav({leveledItems, float = false}) {

    return <div className={`side-nav ${float ? 'float' : ''}`}>
        <div className="nav-items-view-container">
            <NavigationContext.Consumer>
                {
                    ({activeKey}) =>
                        <NavItemsView
                            activeKey={activeKey}
                            leveledItems={leveledItems}
                        />
                }
            </NavigationContext.Consumer>
        </div>
        <div className="locale-switcher-container">
            <LocaleSwitcher/>
        </div>
    </div>;
}
